export const INITIAL_PAGE = 1;
export const INITIAL_PAGE_SIZE = 8;
export const LIST_PAGE_SIZE = 20;
export const INITIAL_PAGE_SIZE_MEDIUM = 12;
